;(function () {
    const sectionGlobe = document.querySelector('.m-flex-bloc-globe');
    if (!sectionGlobe || typeof Globe === 'undefined') return;

    const globeContainer = sectionGlobe.querySelector('#globe');
    if (!globeContainer) return;

    const markers = [
        { name: 'Paris', lat: 48.8566, lng: 2.3522 },
        { name: 'New York', lat: 40.7128, lng: -74.0060 },
        { name: 'Dubaï', lat: 25.2769, lng: 55.2962 },
        { name: 'Singapour', lat: 1.3521, lng: 103.8198 },
    ];

    const globe = new Globe(globeContainer);

    const handleResize = () => {
        globe.width(globeContainer.offsetWidth);
        globe.height(globeContainer.offsetHeight);
    };

    globe
        .backgroundColor('rgba(0,0,0,0)')
        .showAtmosphere(false)
        .showGlobe(true)
        .globeImageUrl('')
        .hexPolygonResolution(3)
        .hexPolygonMargin(0.4)
        .hexPolygonUseDots(true)
        .hexPolygonColor(() => 'rgba(255, 255, 255, 0.7)')
        .hexPolygonAltitude(0.01)
        .htmlAltitude(0.02)
        .pointOfView({ lat: 20, lng: 10, altitude: 1.5 });

    const controls = globe.controls();
    controls.enableZoom = false;
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.5;

    globe.htmlElement((marker) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'globe-marker';

        const inner = document.createElement('div');
        inner.className = 'globe-marker__inner';

        const top = document.createElement('div');
        top.className = 'globe-marker__top';

        const dot = document.createElement('div');
        dot.className = 'globe-marker__dot';
        top.appendChild(dot);

        const label = document.createElement('div');
        label.className = 'globe-marker__label';
        label.innerText = marker.name;
        top.appendChild(label);

        inner.appendChild(top);

        const line = document.createElement('div');
        line.className = 'globe-marker__line';
        inner.appendChild(line);

        wrapper.appendChild(inner);

        return wrapper;
    });

    fetch('https://raw.githubusercontent.com/vasturiano/globe.gl/master/example/datasets/ne_110m_admin_0_countries.geojson')
        .then(res => res.json())
        .then(countries => {
            globe.hexPolygonsData(countries.features);
            globe.htmlElementsData(markers);
            handleResize();
        });

    window.addEventListener('resize', handleResize);
})();
